import { gql, LazyQueryHookOptions, QueryTuple } from '@apollo/client';

import { useAPILazyQuery } from 'Api/handler';

export type GetLocationsResponse = {
  locations: {
    id: number;
    country: string;
    zipcode: string;
    city: string;
    label: string;
  }[];
};

export type GetLocationsVariables = {
  country: string;
  zipcode?: string;
  city?: string;
};

export const useGetLocations = (
  options?: LazyQueryHookOptions<GetLocationsResponse, GetLocationsVariables>,
): QueryTuple<GetLocationsResponse, GetLocationsVariables> => {
  return useAPILazyQuery(GET_LOCATIONS, options);
};

export const GET_LOCATIONS = gql`
  query GetLocations($country: String!, $zipcode: String, $city: String) {
    locations(country: $country, zipcode: $zipcode, city: $city) {
      id
      country
      zipcode
      city
      label
    }
  }
`;
